import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CommunityListsContainer } from './CommunityLists';
import { UGCTabsContainer } from './UGCTabs';

import './Community.scss';

export default class Community extends React.PureComponent {
  render() {
    return (
      <section className="cp-bib-community container">
        <div className="row">
          <div className="col-lg-3">
            <h2>
              <FormattedMessage id="community_section" />
            </h2>
          </div>
          <div className="col-lg-7">
            <CommunityListsContainer />
            <UGCTabsContainer />
          </div>
        </div>
      </section>
    );
  }
}
